import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  createRef,
} from "react";
import getAllHijirDate from "../../../function/getAllHijriDate";
import drawCalacateHijri from "../../../function/drawCalacateHijri";
import ImagePlaceHolder from "../../../common/ImagePlaceHolder";
import { Store } from "../../../state/state";
import { useObserver } from "mobx-react";
import html2canvas from "html2canvas";

import BlockCalender from "./BlockCalender";
import { toJS } from "mobx";
import * as jsPDF from "jspdf";
import { FB } from "../../../config";
import SaveCalendar from "./SaveCalendar";
const ANIMATION = {
  left: "calender-panel-left",
  right: "calender-panel-right",
};

function Calender({
  direction,
  onAdd,
  start,
  onRight,
  onLeft,
  conditionAdd,
  conditionMin,
  onStart,
  onEnd,
}) {
  const store = useContext(Store);

  // const [cols, setCols] = useState([]);
  const [animationClass, setAnimationClass] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingOne, setLoadingOne] = useState(false);
  // const [cols, setCols] = useState([]);
  // let [select, setSelect] = useState(0);
  const [printAll, setPrintAll] = useState(false);
  const ref = useRef(null);
  const [openSaveTheme, setOpenSaveTheme] = useState(false);
  const drawCol = () => {};
  useEffect(() => {
    console.log("apply");
    // setAnimation(!animation);

    setAnimationClass("");

    store.cols = drawCalacateHijri(store.calenderRuslt[store.indexTemp]);
  }, [store.indexTemp]);
  // useEffect(() => {
  //   if (store.indexTemp == 0 && printAll) {
  //     // PrintAll_PDF();
  //     setPrintAll(false);
  //   }
  // }, [store.indexTemp, printAll]);
  // useEffect(() => {
  //   animationSlide();
  // }, [animation]);

  const HeaderWeek = () =>
    useObserver(() => (
      <div
        id="weekly-header"
        className={`transition-all duration-500  cursor-pointer ${
          store.select === "weekly-header"
            ? " selectColor note-scale-stick"
            : ""
        }`}
      >
        <header
          id="weekly-header"
          className={`${store.theme.main.weekHeader.texture}  flex justify-between w-full bg-gray-500  items-center`}
          style={{
            backgroundColor: store.theme.main.weekHeader.backgroundColor,
            color: store.theme.main.weekHeader.text.color,
            fontSize: store.theme.main.weekHeader.text.fontSize + "px",
            fontStyle: store.theme.main.weekHeader.text.fontStyle,
            fontFamily: store.theme.main.weekHeader.text.fontFamily,
            height: "40px",
            maxWidth: "100%",
          }}
        >
          <DayOfMonth>الأحد</DayOfMonth>
          <DayOfMonth>الإثنين</DayOfMonth>
          <DayOfMonth>الثلاثاء</DayOfMonth>
          <DayOfMonth>الأربعاء</DayOfMonth>
          <DayOfMonth>الخميس</DayOfMonth>
          <DayOfMonth>الجمعة</DayOfMonth>
          <DayOfMonth>السبت</DayOfMonth>
        </header>
      </div>
    ));

  const NoteBox = () =>
    useObserver(() => (
      <div className="flex-1 bg-gray-200 flex flex-col ">
        <div
          id="note-header"
          className={`transition-all duration-500  note-scale w-full cursor-pointer  ${
            store.select === "note-header" ? "selectColor note-scale-stick" : ""
          }`}
        >
          <header
            id="note-header"
            className={`py-2 bg-gray-500  text-center ${store.theme.note.header.texture} `}
            style={{
              backgroundColor: store.theme.note.header.backgroundColor,
              color: store.theme.note.header.text.color,
              fontSize: store.theme.note.header.text.fontSize + "px",
              fontStyle: store.theme.note.header.text.fontStyle,
              fontFamily: store.theme.note.header.text.fontFamily,
              height: "40px",
            }}
          >
            الملاحظات
          </header>
        </div>
        <div
          id="note-body"
          className={`flex-1 transition-all duration-500 flex note-scale cursor-pointer ${
            store.select === "note-body" ? "selectColor  note-scale-stick" : ""
          } `}
        >
          <div
            id="note-body"
            className={`flex-1  ${store.theme.note.body.texture} p-2 relative  `}
            style={{
              backgroundColor: store.theme.note.body.backgroundColor,
              overflow: "hidden",
            }}
          >
            <div className="absolute bottom-0 right-0">
              <ImagePlaceHolder id={"image-bottom-right"} />
            </div>
          </div>
        </div>
      </div>
    ));
  const GrideContent = () =>
    useObserver(() => (
      <div className="flex flex-col" style={{ flex: 2.1 }}>
        <HeaderWeek />
        <div
          className={"h-full grid-rows-5 grid grid-cols-7 gap-y-0 "}
          style={{
            backgroundColor: store.theme.main.blockUnActive.backgroundColor,
          }}
        >
          {store.cols.map((data, i) => (
            // <button onClick={() => console.log(toJS(data))}>click</button>
            <BlockCalender data={data} key={data.dayOfMonth} index={i} />
          ))}
        </div>
      </div>
    ));

  const A4 = {
    width: 842,
    height: 595,
  };
  // const PrintAll_PDF = async () => {
  //   const calender = document.querySelector("#calender");
  //   await setLoading(true);
  //   let canvas = await html2canvas(calender, { useCORS: true });
  //   console.log("jsx :", calender);
  //   // await setCols(drawCalacateHijri(store.calenderRuslt[select]));

  //   const imgData = await canvas.toDataURL("image/png");

  //   const pdf = new jsPDF.jsPDF({
  //     orientation: "landscape",
  //   });
  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight = pdf.internal.pageSize.getHeight();
  //   let index = store.;
  //   await pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //   while (index < 11) {
  //     const calender = document.querySelector("#calender");
  //     console.log(
  //       "start=================month(" +
  //         store.calenderRuslt[index].monthName +
  //         ")"
  //     );
  //     console.log(toJS(store.calenderRuslt[index]));
  //     // setRef(document.querySelector("calender"));
  //     console.log("jsx :", calender);

  //     await pdf.addPage();
  //     ++index;
  //     await setSelect(index);
  //     // store.cols = drawCalacateHijri(store.calenderRuslt[select]);
  //     store.cols = await drawCalacateHijri(store.calenderRuslt[select]);
  //     let canvas = await html2canvas(calender, { useCORS: true });
  //     const imgData = await canvas.toDataURL("image/png");
  //     console.log("current page : ", toJS(store.calenderRuslt[select]));
  //     await pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //   }
  //   console.log(`${select}<11  :${select < 11}`);
  //   await pdf.save("download.pdf");
  //   setLoading(false);
  // };
  // const onSaveAll = async () => {
  //   // exportComponentAsPDF(ref);
  //   // await start();
  //   console.log("====");
  //   console.log("====");
  //   console.log("====");
  //   console.log("====");
  //   await setSelect(0);
  //   await setPrintAll(true);
  // };
  // const onSaveTheme = async () => {
  //   let name = window.prompt("اسم المظهر");
  //   let send = {
  //     name,
  //     group: "",
  //     type: "Calendar",
  //     theme: toJS(store.theme),
  //   };

  //   console.log(send);
  //   await FB.collection("theme").doc().set(send);

  //   console.log("لقد تم اضافة المظهر الحالي");
  // };
  // const onSaveOne = async () => {
  //   // exportComponentAsPDF(ref);
  //   const calender = document.querySelector("#calender");

  //   setLoadingOne(true);
  //   // console.log("before :", ref.current);
  //   let canvas = await html2canvas(ref.current, {
  //     useCORS: true,
  //     backgroundColor: null,
  //     allowTaint: true,
  //   });
  // console.log("result svg :", canvas);

  // const imgData = await canvas.toDataURL("image/jpeg");
  // // console.log(imgData);
  // const pdf = new jsPDF.jsPDF({
  //   orientation: "landscape",
  // });
  // // const pdf = new jsPDF.jsPDF("p", "pt", "a4");
  // // var pdf = new jsPDF("p", "pt", "a4");
  // const pdfWidth = pdf.internal.pageSize.getWidth();
  // const pdfHeight = pdf.internal.pageSize.getHeight();
  // console.log(calender);
  // console.log({ pdf });
  // let options = {
  //   // pagesplit: true,
  //   width: pdfWidth,
  //   height: pdfHeight,
  // };
  //   var specialElementHandlers = {
  //     "#elementH": function (element, renderer) {
  //       return true;
  //     },
  //   };
  //   console.log("html :", calender.outerHTML);
  //   // console.log("canvas : ", canvas);
  //   console.log({ pdfHeight, pdfWidth });
  //   // window.print();
  //   console.log("canelnder :", ref.current);
  //   // try {
  //   //   pdf.fromHTML(ref.current, 15, 15, {
  //   //     width: 170,
  //   //     elementHandlers: specialElementHandlers,
  //   //   });
  //   // } catch (error) {
  //   //   console.error(error);
  //   //   window.alert("ERROR :", error.message);
  //   // }

  //   await pdf.addImage(imgData, "jpeg", 0, 0, pdfWidth, pdfHeight);
  //   // await pdf.fromHTML(ref.current, 15, 15, { width: 180, height: 100 });
  //   // await pdf.html(calender, options);
  //   // await pdf.addHTML(ref.current);
  //   // await pdf.addHTML(calender, () => {}).save("download.pdf");
  //   await pdf.save("download.pdf");
  //   setLoadingOne(false);
  // };
  /*
  SkyAnimation-left
  SkyAnimation-center
  */
  return useObserver(() => (
    <div
      id={"empty"}
      className="   flex flex-col    items-center flex-1  h-screen justify-between max-h-screen "
      style={{ width: "70vw" }}
    >
      <div
        className="w-32 py-2 absolute left-0     transform"
        // style={{
        //   transform: "rotate(-45deg) scaleX(1.4)",
        //   left: "-20px",
        //   top: "20px",
        // }}
      >
        <div
          className="bg-btnColor w-full h-8 absolute shadow-btn "
          style={{
            transform: "rotate(-45deg) scaleX(1.4)",
            left: "-20px",
            top: "20px",
          }}
        ></div>
        <div
          className="text-center w-32  text-white "
          style={{
            transform: "rotate(-45deg) translateY(-7px) translateX(-25px)",
            left: "-50px",
          }}
        >
          Demo
        </div>
      </div>
      <div
        id={"empty"}
        className="w-full flex flex-1 relative transition-transform duration-200"
        style={{
          transform: store.preview ? "translateX(15vw)" : "translateX(0px)",
        }}
      >
        <div className=" absolute w-full h-16 ">
          <div
            className="relative w-full h-full  "
            style={{ filter: store.preview ? "blur(5px)" : "blur(0px)" }}
          >
            <img
              className="absolute transition-all duration-500 left-0"
              style={{
                width: "11vw",
                top: "18vh",
                left: store.preview ? "-13vw" : "5vw",
              }}
              src={require("../../../assest/temp-cload-left.png")}
              alt=""
            />
            <img
              className="absolute transition-all duration-500  "
              style={{
                width: "14vw",
                left: store.preview ? "-6vw" : "14vw",
                top: "1vh",
              }}
              src={require("../../../assest/temp-cload-center-left.png")}
              alt=""
            />
            <img
              className="absolute  transition-all duration-500 "
              style={{ width: "12vw", right: store.preview ? "-6vw" : "15vw" }}
              src={require("../../../assest/temp-cload-center-right.png")}
              alt=""
            />
            {/* <img
              className="absolute   "
              style={{
                width: "10vw",
                right: "-2.2vw",
                top: "14vh",
                opacity: store.preview ? "0" : "1",
              }}
              src={require("../../../assest/temp-cload-right.png")}
              alt=""
            /> */}
          </div>
        </div>
        <div
          id={"empty"}
          className={`relative  pt-20 w-full flex  justify-between ${
            !store.preview && "px-20"
          }`}
          style={{
            paddingTop: store.preview ? "15vh" : "15vh",
            width: store.preview ? "90w" : "100%",
          }}
        >
          <div
            className="flex items-center h-full mr-5"
            style={{ height: "595px" }}
          >
            <ArrowIcon
              icon={"fa fa-angle-left"}
              disable={store.indexTemp !== 0}
              onClick={() => --store.indexTemp}
            />
          </div>
          <div
            ref={ref}
            id="calender"
            onselectstart="return false"
            dir="rtl"
            className={
              " h-full bg-gray-400 mt-0 flex  flex-col shadow-2xl shadow-calender transition-all duration-500   " +
              animationClass
            }
            style={{
              MozUserSelect: "none",
              WebkitUserSelect: "none",
              msUserSelect: "none",
              height: "595px",
              width: "842px",
              transform: store.resizeTemplate
                ? store.preview
                  ? "scale(1.3)"
                  : "scale(1.1)"
                : "scale(1)",
              // width: "842px",
              // height: "595px",

              // transform: store.preview ? "scale(1)" : "scale(1.1)",
              // height: window.innerHeight,
              // width: window.innerWidth,
              // transform: store.preview ? "scale(1.3)" : "scale(1)",
            }}
          >
            <div
              className={`transition-all duration-500  note-scale w-full cursor-pointer ${
                store.select === "calendar-header"
                  ? "selectColor note-scale-stick"
                  : ""
              } flex-1 flex`}
            >
              <header
                id="calendar-header"
                className={`flex-1 bg-gray-300 flex justify-between items-center ${store.theme.header.texture}`}
                style={{ backgroundColor: store.theme.header.backgroundColor }}
              >
                <div>
                  <ImagePlaceHolder id="image-center-right" />
                </div>
                <div className="flex items-center">
                  <ImagePlaceHolder id="image-top-right" />
                  <div>
                    <h1
                      className={`text-center font-ElMessiri text-3xl pt-2 ${
                        store.select === "h1" ? "selectColor" : ""
                      }  `}
                      id={"h1"}
                      style={{
                        color: store.theme.header.h1.color,
                        fontSize: store.theme.header.h1.fontSize + "px",
                        fontStyle: store.theme.header.h1.fontStyle,
                        fontFamily: store.theme.header.h1.fontFamily,
                      }}
                    >
                      شهر {store.calenderRuslt[store.indexTemp].monthName}
                    </h1>
                    <h1
                      className={` ${
                        store.select === "h2" ? "selectColor" : ""
                      }  text-center text-gray-600 text-xl pt-2  `}
                      id={"h2"}
                      style={{
                        color: store.theme.header.h2.color,
                        fontSize: store.theme.header.h2.fontSize + "px",
                        fontStyle: store.theme.header.h2.fontStyle,
                        fontFamily: store.theme.header.h2.fontFamily,
                      }}
                    >
                      لعام :{store.calenderRuslt[store.indexTemp].year}
                    </h1>
                  </div>
                  <ImagePlaceHolder id="image-center-left" />
                </div>
                <div>
                  <ImagePlaceHolder id={"image-top-left"} />
                </div>
              </header>
            </div>
            <article className="flex " style={{ flex: 5 }}>
              <NoteBox />
              <GrideContent />
            </article>
          </div>
          <div
            className="flex items-center h-full ml-8"
            style={{ height: "595px" }}
          >
            <ArrowIcon
              icon={"fa fa-angle-right"}
              disable={store.indexTemp < 11}
              className="ml-16"
              onClick={() => ++store.indexTemp}
            />
          </div>
          {/* <div className="w-full flex justify-center items-center  mt-5">
            <ArrowIcon
              icon={"fa fa-angle-double-left"}
              disable={select !== 0}
              onClick={() => setSelect(0)}
            />
      <ArrowIcon
              icon={"fa fa-angle-double-right"}
              disable={select !== 11}
              onClick={() => setSelect(11)}
            />
            <div className="flex items-center mx-5">
              <IndoectorBall value={0} select={select} />
              <IndoectorBall value={1} select={select} />
              <IndoectorBall value={2} select={select} />
              <IndoectorBall value={3} select={select} />
              <IndoectorBall value={4} select={select} />
              <IndoectorBall value={5} select={select} />
              <IndoectorBall value={6} select={select} />
              <IndoectorBall value={7} select={select} />
              <IndoectorBall value={8} select={select} />
              <IndoectorBall value={9} select={select} />
              <IndoectorBall value={10} select={select} />
              <IndoectorBall value={11} select={select} />
            </div>
            <ArrowIcon
              icon={"fa fa-arrow-right"}
              disable={select < 11}
              onClick={() => setSelect(++select)}
            />
      
          </div> */}
          <LoadingPage loading={loading} />
        </div>
      </div>
      <img
        className="fixed  right-0 left-0 bottom-0  w-screen transition-all duration-75 "
        style={{
          height: "22vh",
          filter: store.preview ? "blur(5px)" : "blur(0px)",
        }}
        src={require("../../../assest/bottom-bg.png")}
        alt=""
      />
      {/* <div id="empty" className="flex w-full justify-center h-16 ">
        <Button
          color={"red"}
          icon={"fas fa-file-pdf"}
          onClick={onSaveAll}
          preview={store.preview}
          loading={loading}
        >
          تحميل التقويم
        </Button>
        <Button
          color={"red"}
          icon={"fas fa-file-pdf"}
          onClick={onSaveOne}
          preview={store.preview}
          loading={loadingOne}
        >
          تحميل الحالي فقط
        </Button>
        <Button
          color={"red"}
          icon={"fas fa-save"}
          onClick={() => setOpenSaveTheme(true)}
          preview={store.preview}
        >
          حفظ المظهر
        </Button>
        <SaveCalendar
          onClose={() => setOpenSaveTheme(false)}
          title="حفظ المظهر"
          open={openSaveTheme}
        />
      </div> */}
    </div>
  ));
}
const IndoectorBall = ({ value, select }) => (
  <div
    className={`h-2 w-2 bg-${
      select == value ? "orange" : "gray"
    }-500 mr-2 rounded-full`}
  ></div>
);
const ArrowIcon = ({ disable, onClick, icon }) => (
  <div
    className={`rounded-full mr-2  w-12 h-12 flex justify-center items-center    cursor-pointer  shadow-btn bg-btnColor ${
      !disable ? "text-white" : "text-white"
    }`}
    style={{ zIndex: 4 }}
    onClick={() => {
      if (disable) {
        onClick();
      }
    }}
  >
    <div className={`${icon} text-3xl  opacity-${disable ? "100" : "25"}`} />
  </div>
);
const LoadingPage = ({ loading }) =>
  loading && (
    <div
      className=" absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center "
      style={{ backgroundColor: "rgba(237, 242, 247,0.90)" }}
    >
      <h1
        className="text-5xl text-orange-600 text-center "
        style={{ fontFamily: "Lalezar" }}
      >
        جاري تحميل التقويم <span className="fas fa-spinner fa-spin m" />
      </h1>
    </div>
  );

const Button = ({
  onClick,
  children,
  icon,
  color,
  disable,
  preview,
  loading,
}) => (
  <button
    className={`bg-orange-500 mx-2 ${
      !disable && "hover:bg-orange-600"
    } cursor-pointer ml-5 rounded shadow text-white   py-2 px-10 text-2xl flex  justify-center items-center transition-all duration-500 ${
      disable && "opacity-25"
    }`}
    style={{
      transform: preview ? "translateY(0px)" : "translateY(80px)",
    }}
    onClick={onClick}
    disabled={disable}
  >
    <div className={`${loading ? "fas fa-spinner fa-spin" : icon} mx-5`}></div>

    <span className="text-sm text-center">{children}</span>
  </button>
);
const DayOfMonth = ({ children }) => (
  <span
    id="weekly-header"
    className="flex-1 text-center border-1 py-2 border-white h-full"
  >
    {children}
  </span>
);
export default Calender;
